import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import jobService from "@/services/jobs";

export const useJobsStore = defineStore("jobs", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchJobsGrid(payload) {
    loading.value = true;
    try {
      const res = await jobService.getJobs(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchJobsList(companyId) {
    loading.value = true;
    try {
      const res = await jobService.getJobsList(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addJob(payload) {
    loading.value = true;
    try {
      const res = await jobService.addJob(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editJob(payload) {
    loading.value = true;
    try {
      const res = await jobService.editJob(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchJob(payload) {
    loading.value = true;
    try {
      const res = await jobService.getJob(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchJobsActions(companyId) {
    loading.value = true;
    try {
      const res = await jobService.getJobsActions(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchAllFilesCompany(companyId) {
    loading.value = true;
    try {
      const res = await jobService.getAllFilesCompany(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteJob(payload) {
    loading.value = true;
    try {
      const res = await jobService.deleteJob(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function moveJob(payload) {
    loading.value = true;
    try {
      const res = await jobService.moveJob(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function applyJob(payload) {
    loading.value = true;
    try {
      const res = await jobService.applyJob(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function duplicateJob(payload) {
    loading.value = true;
    try {
      const res = await jobService.duplicateJob(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchJobsGrid,
    fetchJobsList,
    addJob,
    editJob,
    fetchJob,
    fetchJobsActions,
    fetchAllFilesCompany,
    deleteJob,
    moveJob,
    applyJob,
    duplicateJob,
  };
});
